import React from 'react';
import Modal from '../../../Atoms/Modal/Modal';
import TextInput from '../../../Atoms/Inputs/TextInput';
import Buttons from '../../../Atoms/Buttons/Buttons';
import folder from '../../../../assets/Imagess/folderICon.svg';
import ModalChildrenContainer from '../../../Atoms/Modal/ModalChildrenContainer';
import {
  useAddValuesForType,
  useEditValuesForTypes,
} from '../../../../Hooks/Settings';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import LoaderButton from '../../Loader/LoaderButton';
import { useToast } from '../../Custom/CustomToaster/Toast';

const SettingsModal = ({
  handleOnClose,
  title,
  mode,
  type,
  refetchTypes,
  refetchParentOptions,
  selectedItem,
  setSelectedItem,
}) => {
  const customizedToast = useToast();
  const { mutate: addValuesForTypeMutation, isLoading: isAddValues } =
    useAddValuesForType();
  const { mutate: editValueForType, isLoading: isEditting } =
    useEditValuesForTypes();
  const initialValues = {
    arabicName: selectedItem?.text_AR || '',
  };
  const validationSchema = Yup.object().shape({
    arabicName: Yup.string().required('Arabic Name is required'),
  });
  const handleSubmit = (values) => {
    addValuesForTypeMutation(
      {
        typeID: type,
        value: '00000000-0000-0000-0000-000000000000',
        Text_AR: values.arabicName,
      },
      {
        onSuccess: () => {
          handleOnClose();
          refetchTypes();
          refetchParentOptions();
          setSelectedItem({});
          customizedToast.open(`تمت إضافة ${values.arabicName} بنجاح`);
        },
      }
    );
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        {
          mode == 'add'
            ? handleSubmit(values)
            : editValueForType(
                {
                  typeID: selectedItem?.value,
                  Text_AR: values.arabicName,
                },
                {
                  onSuccess: () => {
                    handleOnClose();
                    refetchTypes();
                    refetchParentOptions();
                    setSelectedItem({});
                    customizedToast.open(`تم تحديث ${values.arabicName} بنجاح`);
                  },
                }
              );
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        setFieldValue,
        handleBlur,
        handleSubmit,
        isSubmitting,
      }) => {
        return (
          <Form>
            <Modal
              onClose={handleOnClose}
              title={
                mode == 'add' ? 'إضافة' + ' ' + title : 'تعديل' + ' ' + title
              }
              width='40%'
              closeWhite={false}
            >
              <ModalChildrenContainer noOverflow>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '1rem',
                  }}
                >
                  <TextInput
                    label='الاسم '
                    icon={folder}
                    name='arabicName'
                    placeholder='ادخل الاسم'
                    value={values.arabicName}
                    required={true}
                    onChange={(name, value) => {
                      setFieldValue(name, value);
                    }}
                    errors={errors.arabicName}
                    touched={touched.arabicName}
                    left
                  />

                  {isAddValues || isEditting ? (
                    <LoaderButton />
                  ) : (
                    <div style={{ alignSelf: 'center', width: '30%' }}>
                      <Buttons
                        text={mode == 'add' ? 'حفظ' : 'تحديث'}
                        handleOnClick={handleSubmit}
                        rounded
                      />
                    </div>
                  )}
                </div>
              </ModalChildrenContainer>
            </Modal>
          </Form>
        );
      }}
    </Formik>
  );
};

export default SettingsModal;
